import { TGetTRenewVisaUploadFileDocumentOutputDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-upload-file-document.dto";
import { TRenewVisaUploadFileForm } from "@/features/renew-visa/types/renewVisaUploadFileForm";

export const convertResToUploadApplicationFormData = (
  filterConditionArrayKeys: (keyof TRenewVisaUploadFileForm)[],
  uploadFileData: TGetTRenewVisaUploadFileDocumentOutputDto | undefined,
): TRenewVisaUploadFileForm | undefined => {
  if (!uploadFileData || filterConditionArrayKeys.length === 0) return undefined;
  return {
    annualSalaryReportCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("annualSalaryReportCopyFilePath")
        ? uploadFileData.annualSalaryReportCopyFilePath ?? ""
        : "",

    applicantListFilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantListFilePath") ? uploadFileData.applicantListFilePath ?? "" : "",
    applicantIndividualResidentTaxCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantIndividualResidentTaxCertFilePath")
        ? uploadFileData.applicantIndividualResidentTaxCertFilePath ?? ""
        : "",
    applicantIndividualResidentTaxCertInput: uploadFileData.applicantIndividualResidentTaxCertInput,
    applicantResidentTaxPaymentCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantResidentTaxPaymentCertFilePath")
        ? uploadFileData.applicantResidentTaxPaymentCertFilePath ?? ""
        : "",
    applicantResidentTaxPaymentCertInput: uploadFileData.applicantResidentTaxPaymentCertInput,
    applicantWithholdingSlipCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantWithholdingSlipCopyFilePath")
        ? uploadFileData.applicantWithholdingSlipCopyFilePath ?? ""
        : "",
    applicantWithholdingSlipCopyInput: uploadFileData.applicantWithholdingSlipCopyInput,
    careWorkplaceOverviewFilePath:
      uploadFileData && filterConditionArrayKeys.includes("careWorkplaceOverviewFilePath") ? uploadFileData.careWorkplaceOverviewFilePath ?? "" : "",
    annualCalendarWithLanguageFilePath:
      uploadFileData && filterConditionArrayKeys.includes("annualCalendarWithLanguageFilePath")
        ? uploadFileData.annualCalendarWithLanguageFilePath ?? ""
        : "",
    annualVariableWorkAgreementFilePath:
      uploadFileData && filterConditionArrayKeys.includes("annualVariableWorkAgreementFilePath")
        ? uploadFileData.annualVariableWorkAgreementFilePath ?? ""
        : "",
    certifiedCompanyProofFilePath:
      uploadFileData && filterConditionArrayKeys.includes("certifiedCompanyProofFilePath") ? uploadFileData.certifiedCompanyProofFilePath ?? "" : "",
    corporateResidentTaxPaymentCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("corporateResidentTaxPaymentCertFilePath")
        ? uploadFileData.corporateResidentTaxPaymentCertFilePath ?? ""
        : "",
    corporateResidentTaxPaymentCertInput: uploadFileData.corporateResidentTaxPaymentCertInput,
    specifiedSkillAutomobileMaintenanceCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("specifiedSkillAutomobileMaintenanceCertFilePath")
        ? uploadFileData.specifiedSkillAutomobileMaintenanceCertFilePath ?? ""
        : "",
    specifiedSkillAutomobileMaintenanceIssuranceFilePath:
      uploadFileData && filterConditionArrayKeys.includes("specifiedSkillAutomobileMaintenanceIssuranceFilePath")
        ? uploadFileData.specifiedSkillAutomobileMaintenanceIssuranceFilePath ?? ""
        : "",
    councilMembershipCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("councilMembershipCertFilePath") ? uploadFileData.councilMembershipCertFilePath ?? "" : "",
    hotelBusinessLicenseFilePath:
      uploadFileData && filterConditionArrayKeys.includes("hotelBusinessLicenseFilePath") ? uploadFileData.hotelBusinessLicenseFilePath ?? "" : "",
    hotelBusinessLicenseInput: uploadFileData.hotelBusinessLicenseInput,
    documentOmissionPledgeFilePath:
      uploadFileData && filterConditionArrayKeys.includes("documentOmissionPledgeFilePath")
        ? uploadFileData.documentOmissionPledgeFilePath ?? ""
        : "",

    employmentConditionsCopyFilePaths:
      uploadFileData && filterConditionArrayKeys.includes("employmentConditionsCopyFilePaths")
        ? uploadFileData.employmentConditionsCopyFilePaths ?? []
        : [],
    isExistEmploymentContractCopyFilePath: uploadFileData?.isExistEmploymentContractCopyFilePath ?? false,
    isExistEmploymentConditionsCopyFilePaths: uploadFileData?.isExistEmploymentConditionsCopyFilePaths ?? false,
    employmentContractCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("employmentContractCopyFilePath")
        ? uploadFileData.employmentContractCopyFilePath ?? ""
        : "",
    executiveResidentRecordCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("executiveResidentRecordCopyFilePath")
        ? uploadFileData.executiveResidentRecordCopyFilePath ?? ""
        : "",
    executiveResidentRecordCopyInput: uploadFileData.executiveResidentRecordCopyInput,
    foreignWorkerCompensationStatementFilePaths:
      uploadFileData && filterConditionArrayKeys.includes("foreignWorkerCompensationStatementFilePaths")
        ? uploadFileData.foreignWorkerCompensationStatementFilePaths ?? []
        : [],
    foreignWorkerCompensationStatementInput: uploadFileData.foreignWorkerCompensationStatementInput,
    healthInsuranceWelfarePensionCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("healthInsuranceWelfarePensionCertFilePath")
        ? uploadFileData.healthInsuranceWelfarePensionCertFilePath ?? ""
        : "",
    healthInsuranceWelfarePensionCertInput: uploadFileData.healthInsuranceWelfarePensionCertInput,
    immigrationElectronicSystemPledgeFilePath:
      uploadFileData && filterConditionArrayKeys.includes("immigrationElectronicSystemPledgeFilePath")
        ? uploadFileData.immigrationElectronicSystemPledgeFilePath ?? ""
        : "",
    individualBusinessOwnerResidentCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("individualBusinessOwnerResidentCertFilePath")
        ? uploadFileData.individualBusinessOwnerResidentCertFilePath ?? ""
        : "",
    individualBusinessOwnerResidentCertInput: uploadFileData.individualBusinessOwnerResidentCertInput,
    specifiedSkillForeignWorkerPledgeFilePath:
      uploadFileData && filterConditionArrayKeys.includes("specifiedSkillForeignWorkerPledgeFilePath")
        ? uploadFileData.specifiedSkillForeignWorkerPledgeFilePath ?? ""
        : "",
    specifiedSkillForeignWorkerPledgeInput: uploadFileData.specifiedSkillForeignWorkerPledgeInput,
    constructionSpecifiedSkillAcceptancePlanCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("constructionSpecifiedSkillAcceptancePlanCertFilePath")
        ? uploadFileData.constructionSpecifiedSkillAcceptancePlanCertFilePath ?? ""
        : "",
    constructionSpecifiedSkillAcceptancePlanCertInput: uploadFileData.constructionSpecifiedSkillAcceptancePlanCertInput,
    individualBusinessOwnerTaxOfficePaymentCertNo3FilePath:
      uploadFileData && filterConditionArrayKeys.includes("individualBusinessOwnerTaxOfficePaymentCertNo3FilePath")
        ? uploadFileData.individualBusinessOwnerTaxOfficePaymentCertNo3FilePath ?? ""
        : "",
    individualBusinessOwnerTaxOfficePaymentCertNo3Input: uploadFileData.individualBusinessOwnerTaxOfficePaymentCertNo3Input,
    individualHealthInsurancePaymentCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("individualHealthInsurancePaymentCertFilePath")
        ? uploadFileData.individualHealthInsurancePaymentCertFilePath ?? ""
        : "",
    individualHealthInsurancePaymentCertInput: uploadFileData.individualHealthInsurancePaymentCertInput,
    individualPensionReceiptCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("individualPensionReceiptCopyFilePath")
        ? uploadFileData.individualPensionReceiptCopyFilePath ?? ""
        : "",
    individualPensionReceiptCopyInput: uploadFileData.individualPensionReceiptCopyInput,
    individualResidentTaxCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("individualResidentTaxCertFilePath")
        ? uploadFileData.individualResidentTaxCertFilePath ?? ""
        : "",
    individualResidentTaxCertInput: uploadFileData.individualResidentTaxCertInput,
    innovationCompanyProofFilePath:
      uploadFileData && filterConditionArrayKeys.includes("innovationCompanyProofFilePath")
        ? uploadFileData.innovationCompanyProofFilePath ?? ""
        : "",
    laborInsuranceDelegationFilePath:
      uploadFileData && filterConditionArrayKeys.includes("laborInsuranceDelegationFilePath")
        ? uploadFileData.laborInsuranceDelegationFilePath ?? ""
        : "",
    laborInsuranceDelegationInput: uploadFileData.laborInsuranceDelegationInput,
    laborInsuranceNoDelegationFilePath:
      uploadFileData && filterConditionArrayKeys.includes("laborInsuranceNoDelegationFilePath")
        ? uploadFileData.laborInsuranceNoDelegationFilePath ?? ""
        : "",
    laborInsuranceNoDelegationInput: uploadFileData.laborInsuranceNoDelegationInput,
    nonHealthInsuranceWelfarePensionCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("nonHealthInsuranceWelfarePensionCertFilePath")
        ? uploadFileData.nonHealthInsuranceWelfarePensionCertFilePath ?? ""
        : "",
    nonHealthInsuranceWelfarePensionCertInput: uploadFileData.nonHealthInsuranceWelfarePensionCertInput,
    quarterlyReportCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("quarterlyReportCopyFilePath") ? uploadFileData.quarterlyReportCopyFilePath ?? "" : "",
    registrationCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("registrationCertFilePath") ? uploadFileData.registrationCertFilePath ?? "" : "",
    registrationCertInput: uploadFileData.registrationCertInput,
    socialInsurancePaymentStatusCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("socialInsurancePaymentStatusCertFilePath")
        ? uploadFileData.socialInsurancePaymentStatusCertFilePath ?? ""
        : "",
    socialInsurancePaymentStatusCertInput: uploadFileData.socialInsurancePaymentStatusCertInput,
    specificSkillsInstitutionOfficerAffidavitFilePath:
      uploadFileData && filterConditionArrayKeys.includes("specificSkillsInstitutionOfficerAffidavitFilePath")
        ? uploadFileData.specificSkillsInstitutionOfficerAffidavitFilePath ?? ""
        : "",
    specificSkillsInstitutionOfficerAffidavitInput: uploadFileData.specificSkillsInstitutionOfficerAffidavitInput,
    specificSkillsInstitutionOverviewDocumentFilePath:
      uploadFileData && filterConditionArrayKeys.includes("specificSkillsInstitutionOverviewDocumentFilePath")
        ? uploadFileData.specificSkillsInstitutionOverviewDocumentFilePath ?? ""
        : "",
    specificSkillsInstitutionOverviewDocumentInput: uploadFileData.specificSkillsInstitutionOverviewDocumentInput,
    taxOfficePaymentCertNo3FilePath:
      uploadFileData && filterConditionArrayKeys.includes("taxOfficePaymentCertNo3FilePath")
        ? uploadFileData.taxOfficePaymentCertNo3FilePath ?? ""
        : "",
    taxOfficePaymentCertNo3Input: uploadFileData.taxOfficePaymentCertNo3Input,
    isExistWagePaymentFilePath: uploadFileData?.isExistWagePaymentFilePath ?? false,
    wagePaymentFilePath: uploadFileData && filterConditionArrayKeys.includes("wagePaymentFilePath") ? uploadFileData.wagePaymentFilePath ?? "" : "",
    applicantHealthInsuranceCardCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantHealthInsuranceCardCopyFilePath")
        ? uploadFileData.applicantHealthInsuranceCardCopyFilePath ?? ""
        : "",
    applicantHealthInsuranceCardCopyInput: uploadFileData.applicantHealthInsuranceCardCopyInput,
    applicantHealthInsuranceRecordInquiryResponseFilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantHealthInsuranceRecordInquiryResponseFilePath")
        ? uploadFileData.applicantHealthInsuranceRecordInquiryResponseFilePath ?? ""
        : "",
    applicantHealthInsuranceRecordInquiryResponseInput: uploadFileData.applicantHealthInsuranceRecordInquiryResponseInput,
    applicantHealthInsurancePaymentCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantHealthInsurancePaymentCertFilePath")
        ? uploadFileData.applicantHealthInsurancePaymentCertFilePath ?? ""
        : "",
    applicantHealthInsurancePaymentCertInput: uploadFileData.applicantHealthInsurancePaymentCertInput,
    applicantPensionReceiptCopy1FilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantPensionReceiptCopy1FilePath")
        ? uploadFileData.applicantPensionReceiptCopy1FilePath ?? ""
        : "",
    applicantPensionReceiptCopy1Input: uploadFileData.applicantPensionReceiptCopy1Input,
    applicantPensionRecordInquiry2FilePath:
      uploadFileData && filterConditionArrayKeys.includes("applicantPensionRecordInquiry2FilePath")
        ? uploadFileData.applicantPensionRecordInquiry2FilePath ?? ""
        : "",
    applicantPensionRecordInquiry2Input: uploadFileData.applicantPensionRecordInquiry2Input,
    buildingEnvHealthMgmtRegistrationCertFilePath:
      uploadFileData && filterConditionArrayKeys.includes("buildingEnvHealthMgmtRegistrationCertFilePath")
        ? uploadFileData.buildingEnvHealthMgmtRegistrationCertFilePath ?? ""
        : "",
    buildingEnvHealthMgmtRegistrationCertInput: uploadFileData.buildingEnvHealthMgmtRegistrationCertInput,
    registeredCorporateStructureListPrintedFilePath:
      uploadFileData && filterConditionArrayKeys.includes("registeredCorporateStructureListPrintedFilePath")
        ? uploadFileData.registeredCorporateStructureListPrintedFilePath ?? ""
        : "",
    fishingBoatRegistrationCertCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("fishingBoatRegistrationCertCopyFilePath")
        ? uploadFileData.fishingBoatRegistrationCertCopyFilePath ?? ""
        : "",
    fishingBoatRegistrationCertCopyInput: uploadFileData.fishingBoatRegistrationCertCopyInput,
    fishingBoatRegistryCopyFilePath:
      uploadFileData && filterConditionArrayKeys.includes("fishingBoatRegistryCopyFilePath")
        ? uploadFileData.fishingBoatRegistryCopyFilePath ?? ""
        : "",
    fishingBoatRegistryCopyInput: uploadFileData.fishingBoatRegistryCopyInput,
    fishingCooperativeMembershipDocumentFilePath:
      uploadFileData && filterConditionArrayKeys.includes("fishingCooperativeMembershipDocumentFilePath")
        ? uploadFileData.fishingCooperativeMembershipDocumentFilePath ?? ""
        : "",
    fishingCooperativeMembershipDocumentInput: uploadFileData.fishingCooperativeMembershipDocumentInput,
    fishingCooperativeRightsDocumentFilePath:
      uploadFileData && filterConditionArrayKeys.includes("fishingCooperativeRightsDocumentFilePath")
        ? uploadFileData.fishingCooperativeRightsDocumentFilePath ?? ""
        : "",
    fishingCooperativeRightsDocumentInput: uploadFileData.fishingCooperativeRightsDocumentInput,
    fishingLicenseCopy1FilePath:
      uploadFileData && filterConditionArrayKeys.includes("fishingLicenseCopy1FilePath") ? uploadFileData.fishingLicenseCopy1FilePath ?? "" : "",
    fishingLicenseCopy1Input: uploadFileData.fishingLicenseCopy1Input,
    fishingLicenseCopy2FilePath:
      uploadFileData && filterConditionArrayKeys.includes("fishingLicenseCopy2FilePath") ? uploadFileData.fishingLicenseCopy2FilePath ?? "" : "",
    fishingLicenseCopy2Input: uploadFileData.fishingLicenseCopy2Input,
    fishingLicenseCopy3FilePath:
      uploadFileData && filterConditionArrayKeys.includes("fishingLicenseCopy3FilePath") ? uploadFileData.fishingLicenseCopy3FilePath ?? "" : "",
    fishingLicenseCopy3Input: uploadFileData.fishingLicenseCopy3Input,
    previousApplicationDocumentsFilePath:
      uploadFileData && filterConditionArrayKeys.includes("previousApplicationDocumentsFilePath")
        ? uploadFileData.previousApplicationDocumentsFilePath ?? ""
        : "",
    publicDutyPledgeFilePath:
      uploadFileData && filterConditionArrayKeys.includes("publicDutyPledgeFilePath") ? uploadFileData.publicDutyPledgeFilePath ?? "" : "",
    publicDutyComplianceFilePath:
      uploadFileData && filterConditionArrayKeys.includes("publicDutyComplianceFilePath") ? uploadFileData.publicDutyComplianceFilePath ?? "" : "",
    shipbuildingIndustryConfirmationFilePath:
      uploadFileData && filterConditionArrayKeys.includes("shipbuildingIndustryConfirmationFilePath")
        ? uploadFileData.shipbuildingIndustryConfirmationFilePath ?? ""
        : "",
    shipbuildingIndustryConfirmationInput: uploadFileData.shipbuildingIndustryConfirmationInput,
    ryokanBusinessLicenseFilePath:
      uploadFileData && filterConditionArrayKeys.includes("ryokanBusinessLicenseFilePath") ? uploadFileData.ryokanBusinessLicenseFilePath ?? "" : "",
    ryokanBusinessLicenseInput: uploadFileData.ryokanBusinessLicenseInput,
    adultEntertainmentBusinessLicenseFilePath:
      uploadFileData && filterConditionArrayKeys.includes("adultEntertainmentBusinessLicenseFilePath")
        ? uploadFileData.adultEntertainmentBusinessLicenseFilePath ?? ""
        : "",
    adultEntertainmentBusinessLicenseInput: uploadFileData.adultEntertainmentBusinessLicenseInput,
    businessLicenseOrNotificationFormFilePath:
      uploadFileData && filterConditionArrayKeys.includes("businessLicenseOrNotificationFormFilePath")
        ? uploadFileData.businessLicenseOrNotificationFormFilePath ?? ""
        : "",

    businessLicenseOrNotificationFormInput: uploadFileData.businessLicenseOrNotificationFormInput,
    specificSkillOrganizationOverviewFilePath:
      uploadFileData && filterConditionArrayKeys.includes("specificSkillOrganizationOverviewFilePath")
        ? uploadFileData.specificSkillOrganizationOverviewFilePath ?? ""
        : "",
    specificSkillOrganizationOverviewInput: uploadFileData.specificSkillOrganizationOverviewInput,
    residenceApplicationsForEmployeeTable1FilePath:
      uploadFileData && uploadFileData.residenceApplicationsForEmployeeTable1FilePath
        ? uploadFileData.residenceApplicationsForEmployeeTable1FilePath
        : "",
    residenceApplicationsForEmployeeTable2And1FilePath:
      uploadFileData && uploadFileData.residenceApplicationsForEmployeeTable2And1FilePath
        ? uploadFileData.residenceApplicationsForEmployeeTable2And1FilePath
        : "",
    residenceApplicationsForEmployeeTable2And2FilePath:
      uploadFileData && uploadFileData.residenceApplicationsForEmployeeTable2And2FilePath
        ? uploadFileData.residenceApplicationsForEmployeeTable2And2FilePath
        : "",
    residenceApplicationsForEmployeeTable2And3FilePath:
      uploadFileData && uploadFileData.residenceApplicationsForEmployeeTable2And3FilePath
        ? uploadFileData.residenceApplicationsForEmployeeTable2And3FilePath
        : "",
    residenceApplicationsForEmployeeTable3And1FilePath:
      uploadFileData && uploadFileData.residenceApplicationsForEmployeeTable3And1FilePath
        ? uploadFileData.residenceApplicationsForEmployeeTable3And1FilePath
        : "",
    residenceApplicationsForEmployeeTable3And2FilePath:
      uploadFileData && uploadFileData.residenceApplicationsForEmployeeTable3And2FilePath
        ? uploadFileData.residenceApplicationsForEmployeeTable3And2FilePath
        : "",
    residenceApplicationsForEmployeeTable3And3FilePath:
      uploadFileData && uploadFileData.residenceApplicationsForEmployeeTable3And3FilePath
        ? uploadFileData.residenceApplicationsForEmployeeTable3And3FilePath
        : "",
  };
};
